import type { BaseDocument } from '../mongo/base-document.interface';

export const USER_PREFERENCE_CATEGORY = {
  ALL: 'all',
  BACKOFFICE: 'backoffice',
  FRONTOFFICE: 'frontoffice',
  KLAREO_GO: 'klareo_go',
} as const;

export type UserPreferenceCategory = (typeof USER_PREFERENCE_CATEGORY)[keyof typeof USER_PREFERENCE_CATEGORY];

export interface UserPreference extends BaseDocument {
  category: UserPreferenceCategory;
  key: string;
  userId: string;
  value: unknown;
}

export type UpsertUserPreference = Omit<UserPreference, keyof BaseDocument | 'userId'>;
